import React from "react";
import { type ButtonProps, Button } from "components/Atoms/Button";

const PanelSegmentButton = (props: ButtonProps) => {
  return <div className={props.className}>
    <Button
      {...props}
      onClick={props.onClick}
    />
  </div>;
};

export default PanelSegmentButton;